/**
 * The focused screen's scrollable DOM node, web only.
 *
 * AppColumn paints the phone-width column's leftover window width as plain
 * background (see APP_MAX_WIDTH) — a wheel event over that margin has no
 * scrollable ancestor to land on. PageScrollView and PageFlatList publish
 * their node here while focused; AppColumn reads it to forward the margin's
 * wheel deltas onto whichever screen is actually visible.
 */
export const activeScrollTarget: {
  current: { scrollBy(options: { top?: number; left?: number }): void } | null;
} = { current: null };
